// extracted by mini-css-extract-plugin
module.exports = {"canvasContainer":"PhoneCanvas_canvasContainer__Ggatt"};